import type { Bulle, Priorite } from '../partage/api/types';

/**
 * Le calque d'importance (ticket 04 du chantier `priorites`, décision d'Igor du 2026-09-27 ;
 * Urgent, Important, Quand tu veux depuis le chantier `flottaison`) : dans ⚙, on met une
 * importance en avant, et tout le reste s'efface, en Carte comme en
 * Hiérarchie. Rien ne bouge : la carte ne dépend pas de la priorité, seul ce qui ressort
 * change. Avec les losanges de profondeur, on voit niveau après niveau où elle se cache : au
 * niveau 1 les étapes du premier tour, au niveau 2 celles qui en contiennent, avec leur
 * nombre, au niveau 3 les bulles elles-mêmes.
 *
 * Le serveur compte, pour chaque bulle connue, combien elle porte de chaque priorité
 * (`calqueDePriorite.ts`). Une bulle qu'il n'a pas comptée (plus bas que ce que la carte
 * connaît, en Hiérarchie) se juge sur sa propre priorité.
 */
export type Calque = Record<string, Partial<Record<Priorite, number>>>;

export interface DansLeCalque {
  /** Elle porte cette priorité, elle ou ce qu'elle contient : elle reste allumée. */
  allumee: boolean;
  /** Combien elle en contient, pour une étape allumée ; `null` pour une tâche. */
  combien: number | null;
}

const TOUT_ALLUME: DansLeCalque = { allumee: true, combien: null };

export function dansLeCalque(
  bulle: Pick<Bulle, 'id' | 'priorite'> & { nbEnfants: number },
  enAvant: Priorite | null,
  calque: Calque
): DansLeCalque {
  if (enAvant === null) return TOUT_ALLUME;
  const compte = calque[bulle.id];
  const combien = compte ? (compte[enAvant] ?? 0) : bulle.priorite?.retenue === enAvant ? 1 : 0;
  return {
    allumee: combien > 0,
    combien: combien > 0 && bulle.nbEnfants > 0 && compte ? combien : null,
  };
}
